import MaterialTable from "material-table";
import tableIcons from "../../../utils/tableIcons";
import DeleteIcon from "../../../assets/delete-icon.png";
import { useEffect, useRef, useState } from "react";
import { Button, Empty, Modal, message } from "antd";
import {
  DeleteServiceProviderService,
  GetServiceProviderCategories,
  GetServiceProviderServiceList,
} from "../../../utils/api";
import { useParams } from "react-router-dom";
import Loader from "../../shared/Loader";
import { convertToViewableAmount } from "../../../utils/helper";

const Services = () => {
  const { id } = useParams();
  const [modalData, setModalData] = useState({
    visible: false,
    selectedStatus: "",
    service: "",
    id: "",
    action: "",
  });
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const tableRef = useRef(null);

  const columns = [
    {
      title: "Id",
      field: "id",
      sorting: true,
      align: "left",
      cellStyle: { width: "25%" },
    },
    {
      title: "Service Name",
      field: "title",
      sorting: true,
      align: "center",
      cellStyle: { width: "25%" },
      render: (record) => {
        return <span className="mr-7">{record.title}</span>;
      },
    },
    {
      title: "Price",
      field: "price",
      sorting: true,
      align: "center",
      cellStyle: { width: "25%" },
      render: (record) => {
        return (
          <span className="mr-8">{convertToViewableAmount(record?.price)}</span>
        );
      },
    },
    {
      title: "Action",
      sorting: false,
      cellStyle: { width: "25%" },
      align: "right",
      render: (record) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() => handleActionModalOpen("delete", "", record)}
          >
            <img
              alt="show-icon"
              className="ml-auto mr-4"
              src={DeleteIcon}
              width={16}
            />
          </span>
        );
      },
    },
  ];

  const handleActionModalOpen = (action, status, service) => {
    if (action === "delete") {
      setModalData({
        visible: true,
        service: service.title,
        id: service.id,
        selectedStatus: "",
        action: "delete",
      });
    } else if (action === "changeStatus") {
      setModalData({
        visible: true,
        service: service.title,
        selectedStatus: status,
        id: "",
        action: "changeStatus",
      });
    }
  };

  const handleModalCancel = () => {
    setModalData({ visible: false, selectedStatus: "", user: "", id: "" });
  };

  const handleChangeStatusOk = () => {};

  const handleDeleteOk = async () => {
    if (modalData.action === "delete") {
      try {
        setBtnLoading(true);
        const res = await DeleteServiceProviderService(modalData?.id);
        setBtnLoading(false);
        if (res?.isSuccess) {
          message.success("Service Deleted successfully");
          setModalData({
            id: null,
            visible: false,
            selectedStatus: null,
            user: null,
            action: null,
          });
          getServices();
        } else {
          setLoading(false);
          message.error(res?.error);
        }
      } catch (error) {
        setBtnLoading(false);
        message.error("Error in deletion, Try again later");
      }
    }
  };

  const getCategories = async () => {
    setLoading(true);
    try {
      const res = await GetServiceProviderCategories(id);
      if (res?.isSuccess) {
        const dataArray = Object.keys(res?.data).map((category) => ({
          category,
          items: res?.data[category],
        }));
        setCategories(dataArray);
        setLoading(false);
      } else {
        setLoading(false);
        message.error("Error while fetching Categories, Please try again");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getServices = async () => {
    setLoading(true);
    try {
      const response = await GetServiceProviderServiceList(id);
      if (response?.isSuccess) {
        setServices(response?.data);
        setLoading(false);
      } else {
        setLoading(false);
        message.error(response?.error);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getCategories();
      getServices();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="w-full flex flex-col gap-y-6 pt-4">
        <div className="w-full flex items-center justify-between gap-x-6 px-6">
          <div className="w-full flex flex-col gap-4 pb-3">
            <div className="flex">
              <h2 className="w-1/2 text-lg font-semibold border-primary-900">
                Categories
              </h2>
              <h2 className="px-4 w-1/2 text-lg font-semibold">
                Sub Categories
              </h2>
            </div>

            {categories &&
              categories?.length > 0 &&
              categories?.map((cat, index) => {
                return (
                  <div className="flex" key={index}>
                    <div className=" w-1/2 flex flex-col gap-y-4 border-r border-primary-700 py-1">
                      <div>
                        <span className="bg-primary-600 py-1 px-3 rounded-3xl text-primary-900 font-medium">
                          {cat?.category}
                        </span>
                      </div>
                    </div>
                    <div className="px-4 w-1/2 flex flex-wrap gap-4 py-1">
                      {cat?.items &&
                        cat?.items?.length > 0 &&
                        cat?.items?.map((item, index) => {
                          if (item === null) {
                            return (
                              <span
                                key={index}
                                className="border border-primary-600 py-1 px-3 rounded-full text-primary-900 font-medium"
                              >
                                No Subcategory
                              </span>
                            );
                          }
                          return (
                            <div key={index}>
                              <span className="border border-primary-600 py-1 px-3 rounded-full text-primary-900 font-medium">
                                {item}
                              </span>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              })}

            {categories && categories?.length === 0 && (
              <div className="w-full text-center my-16 font-medium text-primary-900 text-xl">
                <Empty />
              </div>
            )}
          </div>
        </div>

        <div className="service-table-custom w-full flex flex-col gap-y-4">
          <h2 className="text-lg font-semibold px-6">Service List</h2>
          {services && services?.length > 0 ? (
            <MaterialTable
              tableRef={tableRef}
              title="Services"
              columns={columns}
              icons={tableIcons}
              options={{
                showTitle: false,
                draggable: false,
                debounceInterval: 700,
                paging: false,
                padding: "dense",
                search: false,
              }}
              data={services}
            />
          ) : (
            <div className="w-full text-center my-16 font-medium text-primary-900 text-xl">
              <Empty />
            </div>
          )}
        </div>
      </div>

      <Modal
        centered
        title={
          modalData.action === "delete"
            ? "Confirm Delete"
            : "Confirm Status Change"
        }
        open={modalData.visible}
        onCancel={handleModalCancel}
        footer={
          <div>
            <Button onClick={handleModalCancel}>Cancel</Button>
            <Button
              type="primary"
              className="text-white"
              onClick={
                modalData.action === "delete"
                  ? handleDeleteOk
                  : handleChangeStatusOk
              }
            >
              Ok
              {btnLoading && (
                <span className="loader ml-2 align-middle mb-1"></span>
              )}
            </Button>
          </div>
        }
      >
        {modalData.action === "changeStatus"
          ? `Are you sure you want to change the status of ${modalData.service} to ${modalData.selectedStatus}?`
          : `Are you sure you want to delete ${modalData.service}?`}
      </Modal>
    </>
  );
};

export default Services;
